import { useEffect, useCallback, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { KNM_HISTORY, KNM_EXECUTION_HISTORY } from 'CorePackage/MainModule/routes/routes';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  getKnmHistoryChanges,
  getKnmHistoryChangesIsLoading,
  getKnmHistoryChangesIsOn,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { knmGetHistoryChanges, knmSetHistoryChangesIsOn } from 'KnmPackage/MainModule/actions/knmActions';
import { IKnmHistoryChanges } from 'KnmPackage/MainModule/interfaces/IKnmHistoryChanges';

import { KnmHistory } from './KnmHistory';

interface IKnmHistoriesProps {
  title: string;
  executionTitle?: string;
  knmHistoryChangesIsOn: boolean;
  knmHistoryChanges?: IKnmHistoryChanges;
  knmHistoryChangesIsLoading: boolean;
}

export const KnmHistoriesWithoutStore = ({
  title,
  executionTitle,
  knmHistoryChangesIsOn,
  knmHistoryChanges,
  knmHistoryChangesIsLoading,
}: IKnmHistoriesProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const blockRef = useRef<HTMLDivElement>(null);

  const updateDidVisible = useCallback(() => {
    const blockOffsetTop = blockRef.current?.getBoundingClientRect().top;

    if (blockOffsetTop && blockOffsetTop - document.documentElement.clientHeight < 0) {
      if (!knmHistoryChangesIsOn) {
        dispatch(knmSetHistoryChangesIsOn(true));
        dispatch(knmGetHistoryChanges());
      }
    }
  }, [dispatch, knmHistoryChangesIsOn]);

  useEffect(() => {
    updateDidVisible();
    window.addEventListener('scroll', updateDidVisible);

    return () => window.removeEventListener('scroll', updateDidVisible);
  }, [updateDidVisible]);

  return (
    <>
      <KnmHistory
        id={KNM_HISTORY}
        title={title}
        blockRef={blockRef}
        loading={knmHistoryChangesIsLoading}
        historyChanges={knmHistoryChanges?.main || []}
      />
      {executionTitle && (
        <KnmHistory
          id={KNM_EXECUTION_HISTORY}
          title={executionTitle}
          loading={knmHistoryChangesIsLoading}
          historyChanges={knmHistoryChanges?.execution || []}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: IRootState) => ({
  knmHistoryChangesIsOn: getKnmHistoryChangesIsOn(state),
  knmHistoryChanges: getKnmHistoryChanges(state),
  knmHistoryChangesIsLoading: getKnmHistoryChangesIsLoading(state),
});

export const KnmHistories = connect(mapStateToProps)(KnmHistoriesWithoutStore);
